import { MaintenanceWindowsDeleteDialogController } from '../controller/MaintenanceWindowsDeleteDialogController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class MaintenanceWindowsDeleteDialogWebComponent extends BaseWebComponentElement {
  private _companyId: string;
  private _maintenanceWindowIds: string[];
  public controller: MaintenanceWindowsDeleteDialogController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: MaintenanceWindowsDeleteDialogController,
    });
  }

  get companyId(): string {
    return this._companyId;
  }

  set companyId(value: string) {
    this._companyId = value;
  }

  get maintenanceWindowIds(): string[] {
    return this._maintenanceWindowIds ?? [];
  }

  set maintenanceWindowIds(value: string[]) {
    this._maintenanceWindowIds = value;
  }
}
